import { Box } from '@mui/material';
import { createPortal } from 'react-dom';
import { useWatch } from 'react-hook-form';

import { RemarkButton } from '@Components/IconButton';
import Remark from '@Components/Remark';
import { useDisclosure } from '@hooks/useDisclosure';

import { useGreenhouseForm } from '../../EsgGreenhouseFormProvider';
import {
  IGhGasEmissionVolumeFormValues,
  IPerformanceGhGasMgmtReportFormValues,
} from '../../EsgGreenhouseFormProvider/types';

export const PREFIX_GH_GAS_EMISSTION_ORG_ID = 'gh-gas-emisstion-org-remark';

type GreenhouseGasEmissionOrganizationRemarkProps = {
  topic: string;
  name: 'remarkTotalGhGas' | 'remarkScope1' | 'remarkScope2' | 'remarkScope3';
};

const GreenhouseGasEmissionOrganizationRemark = ({
  topic,
  name,
}: GreenhouseGasEmissionOrganizationRemarkProps) => {
  const { control, getValues } = useGreenhouseForm();
  const emissionVolume =
    getValues(`performanceGhGasMgmtReport.ghGasEmissionVolume`) ??
    ({} as IGhGasEmissionVolumeFormValues);

  const [isRemarkOpen, { open, close }] = useDisclosure(
    !!emissionVolume?.[name]
  );

  const ghGasEmissionRemarkEl = document.getElementById(
    `${PREFIX_GH_GAS_EMISSTION_ORG_ID}-${name}`
  );

  const { completedSection } =
    useWatch({
      name: 'performanceGhGasMgmtReport',
      control,
    }) ?? ({} as IPerformanceGhGasMgmtReportFormValues);

  const { isCompletedTh = false, isCompletedEn = false } =
    completedSection ?? {};

  return (
    <>
      <RemarkButton onClick={open} disabled={isCompletedTh && isCompletedEn} />
      {isRemarkOpen &&
        ghGasEmissionRemarkEl &&
        createPortal(
          <Box mt={2}>
            <Remark
              onDelete={close}
              topic={topic}
              setOpen={open}
              fieldPath={`performanceGhGasMgmtReport.ghGasEmissionVolume.${name}`}
              isCompletedEn={isCompletedEn}
              isCompletedTh={isCompletedTh}
            />
          </Box>,
          ghGasEmissionRemarkEl
        )}
    </>
  );
};

export default GreenhouseGasEmissionOrganizationRemark;
